import React, { useState, useContext } from "react";

import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Box from "@mui/material/Box";
import { Star, StarBorder, Reply, Shortcut, DeleteOutlined, ContentCopyOutlined } from "@mui/icons-material";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import ForwardMessageModal from "../ForwardMessageModal";
import { Menu } from "@mui/material";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import { toast } from "../../services/toast";

const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

const MessageOptionsMenu = ({ message, ticket, menuOpen, handleClose, anchorEl }) => {
	const { setReplyingMessage } = useContext(ReplyMessageContext);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [forwardOpen, setForwardOpen] = useState(false);

	const handleDeleteMessage = async () => {
		try {
			await api.delete(`/messages/${message.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const hanldeReplyMessage = () => {
		setReplyingMessage(message);
		handleClose();
	};

	const handleOpenForwardModal = () => {
		setForwardOpen(true);
		handleClose();
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleToggleStar = async () => {
		try {
			await api.put(`/messages/${message.id}/star`);
		} catch (err) {
			toastError(err);
		}
		handleClose();
	};

	const handleReact = async (emoji) => {
		try {
			await api.put(`/messages/${message.id}/react`, { emoji });
		} catch (err) {
			toastError(err);
		}
		handleClose();
	};

	const handleCopyMessage = async () => {
		try {
			await navigator.clipboard.writeText(message.body || "");
			toast.success("Mensaje copiado");
		} catch (err) {
			toast.error("No se pudo copiar");
		}
		handleClose();
	};

	return (
		<>
			<ConfirmationModal
				title={i18n.t("messageOptionsMenu.confirmationModal.title")}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteMessage}
			>
				{i18n.t("messageOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<ForwardMessageModal
				message={message}
				sourceWhatsappId={ticket?.whatsappId}
				modalOpen={forwardOpen}
				onClose={() => setForwardOpen(false)}
			/>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				<Box sx={{ display: "flex", justifyContent: "space-around", px: 1, py: 0.5 }}>
					{QUICK_REACTIONS.map((emoji) => (
						<Box
							key={emoji}
							component="span"
							onClick={() => handleReact(emoji)}
							sx={{
								cursor: "pointer",
								fontSize: 20,
								borderRadius: "50%",
								padding: "2px 4px",
								opacity: message.reaction === emoji ? 1 : 0.6,
								backgroundColor: message.reaction === emoji ? "action.selected" : "transparent",
								"&:hover": { opacity: 1, backgroundColor: "action.hover" },
							}}
						>
							{emoji}
						</Box>
					))}
				</Box>
				{message.fromMe && (
					<MenuItem onClick={handleOpenConfirmationModal}>
						<ListItemIcon>
							<DeleteOutlined fontSize="small" />
						</ListItemIcon>
						{i18n.t("messageOptionsMenu.delete")}
					</MenuItem>
				)}
				<MenuItem onClick={hanldeReplyMessage}>
					<ListItemIcon>
						<Reply fontSize="small" />
					</ListItemIcon>
					{i18n.t("messageOptionsMenu.reply")}
				</MenuItem>
				{message.body && (
					<MenuItem onClick={handleCopyMessage}>
						<ListItemIcon>
							<ContentCopyOutlined fontSize="small" />
						</ListItemIcon>
						Copiar
					</MenuItem>
				)}
				<MenuItem onClick={handleToggleStar}>
					<ListItemIcon>
						{message.isStarred ? <Star fontSize="small" color="warning" /> : <StarBorder fontSize="small" />}
					</ListItemIcon>
					{message.isStarred ? "Quitar destacado" : "Marcar como destacado"}
				</MenuItem>
				<MenuItem onClick={handleOpenForwardModal}>
					<ListItemIcon>
						<Shortcut fontSize="small" />
					</ListItemIcon>
					Reenviar
				</MenuItem>
			</Menu>
		</>
	);
};

export default MessageOptionsMenu;
